import api from '@/api'
import { comparadorString } from '@/helpers/FunctionHelper'


const state = {
  organismos: []
}

const getters = {
  organismos: (state) => {
    return [...state.organismos].sort((a, b) => comparadorString.compare(a.ORGANISMO, b.ORGANISMO))
  }
}

const mutations = {
  SET_ORGANISMOS(state, organismos) {
    state.organismos = organismos
  }
}

const actions = {
  async fetchOrganismos({ commit }) {
    try {
      const response = await api.organismo.getOrganismos()
      commit('SET_ORGANISMOS', response.data)

    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
